(function($){


	function getDevice() {
	    var device = window.getComputedStyle(document.body,':after').getPropertyValue('content');

	    if (device.indexOf('mobile') != -1)
	        return 'mobile';
		if (device.indexOf('tablet') != -1)
			return 'tablet';
	    if (device.indexOf('desktop') != -1)
			return 'desktop';
	    return false;
	}


	$('.toggleLayerOffre').on('click', function (event) {
		event.preventDefault();
		$('.layerOffre').toggleClass('open'); //mobile
		if(getDevice()=="desktop")
			$('.layerOffre').slideToggle(); //desktop
	});


	function closeLayerOffre() {
		$('.layerOffre').removeClass('open'); //mobile
		if(getDevice()=="desktop")
			$('.layerOffre').hide(); //desktop
		
	}

	$('.burger').on('click', function (event) {
		closeLayerOffre();
	});

	//ON SCROLL
	$(window).scroll(closeLayerOffre);
    //ON RESIZE
    $(window).resize(closeLayerOffre);
	
})(jQuery)

